"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NorthsInfinitumAbilityHandler = exports.NorthsInfinitumActorAbilityFactory = exports.NorthsInfinitumAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const MaxAttributeIncrease_1 = require("../../core/effects/core/MaxAttributeIncrease");
const AttributeType_1 = require("../../core/enums/AttributeType");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class NorthsInfinitumAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.NorthsInfinitum;
        this.__typeName = "NorthsInfinitum";
    }
}
exports.NorthsInfinitumAbilityArgs = NorthsInfinitumAbilityArgs;
let NorthsInfinitumActorAbilityFactory = class NorthsInfinitumActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("NorthsInfinitum", "AllAllies", 4);
    }
};
NorthsInfinitumActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("NorthsInfinitum")
], NorthsInfinitumActorAbilityFactory);
exports.NorthsInfinitumActorAbilityFactory = NorthsInfinitumActorAbilityFactory;
let NorthsInfinitumAbilityHandler = class NorthsInfinitumAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId: ability.invokerId,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.Health, container.getPercentOfBaseHealth(ability.invokerId, 50))
                });
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                    .forEach(ally => {
                    const additionalEffects = Array.of();
                    if (container.hasAttribute(ability.invokerId, "Charm_Augur_0")) {
                        additionalEffects.push(new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.Health, container.getPercentOfBaseAttributeScore(ally, 25, "Health")));
                    }
                    container.applyBuff({
                        sequence,
                        creatorId: ability.invokerId,
                        targetId: ally,
                        duration: Duration_1.Duration.Turns(4),
                        effect: new core_1.LinkedEffectsEffectArgs([
                            ...Array.from(AttributeType_1.PRIMARY_ATTRIBUTES).map(attr => new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(attr, container.getPercentOfBaseAttributeScore(ally, 10, attr))),
                            ...additionalEffects
                        ], false),
                        onApplied: sequence => sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(ally, "feet"), "DivineBubble"))
                    });
                });
            }
        });
    }
};
NorthsInfinitumAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.NorthsInfinitum)
], NorthsInfinitumAbilityHandler);
exports.NorthsInfinitumAbilityHandler = NorthsInfinitumAbilityHandler;
